import React from 'react';

import { replace } from '../config/constants';

export default ({ cups, quantities, steps }) => {
  const newSteps = cups === 2 ? steps : steps.filter(step => !step.condition);

  return (
    <div className="steps mb32">
      <div className="steps--divider">
        <span className="steps--divider-title">STEP BY STEP</span>
      </div>
      {newSteps.map((step, index) => (
        <div className="steps--card" key={index}>
          <div className="steps--card--detail">
            <p className="steps--card--detail-title">{index + 1}</p>
            <p className="steps--card--detail-sub">{replace(step.direction, quantities[cups -1])}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
